import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <h1>{{ 'manage.Audit log' | translate }}</h1>
        <manage-logs-auditlog-filter list="vm.list" default-filter="vm.defaultFilter"></manage-logs-auditlog-filter>
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <pagination-tools list="vm.list"></pagination-tools>
            <div class="loader01" ng-if="vm.list.loading">
                <p>{{ 'general.Please wait. Actions with large amount of data take more time than usual' | translate }}</p>
            </div>
            <table
                class="data01"
                datatable
                dt-options="vm.DATATABLES"
                ng-init="vm.AuditLogService.buildLinks(vm.list.items)">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('timestamp')"><a ng-click="vm.list.sortBy('timestamp')">{{ 'auditLog.Time' | translate }}</a></th>
                        <th>{{ 'auditLog.Activity' | translate }}</th>
                        <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'auditLog.User' | translate }}</a></th>
                        <th ng-class="vm.list.getSortClass('id')"><a ng-click="vm.list.sortBy('id')">{{ 'auditLog.Reference' | translate }}</a></th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td>{{ vm.moment(item.timestamp * 1000).format('DD.MM.YYYY HH:mm:ss') }}</td>
                        <td>
                            {{ vm.AUDITLOG_ENUM.LABELS[item.action] }}
                            <a ng-if="item.link" ng-href="{{ item.link }}">{{ item.activeI18n.linkText }}</a>
                            <span ng-if="!item.link && item.activeI18n.linkText">({{ item.activeI18n.linkText }})</span>
                        </td>
                        <td>
                            <span ng-if="item.type===vm.AUDITLOG_TYPE_ENUM.KEYS.USER_SPECIFIC">{{ item.relatedUser.displayName }}</span>
                            <span ng-if="item.type!==vm.AUDITLOG_TYPE_ENUM.KEYS.USER_SPECIFIC">{{ vm.AUDITLOG_TYPE_ENUM.LABELS[item.type] }}</span>
                        </td>
                        <td>{{ item.id }}</td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor ($state, $translate, moment, ListFactory, AuditLogResource, DATATABLES, AUDITLOG_ENUM, AUDITLOG_TYPE_ENUM,
                 AuditLogService) {
        this.$state = $state;
        this.$translate = $translate;
        this.moment = moment;
        this.DATATABLES = DATATABLES;
        this.AUDITLOG_ENUM = AUDITLOG_ENUM;
        this.AUDITLOG_TYPE_ENUM = AUDITLOG_TYPE_ENUM;
        this.AuditLogService = AuditLogService;
        this.defaultFilter = { expand: 'relatedUser,activeI18n' };
        this.list = ListFactory.createWithPagination(AuditLogResource.query.bind(AuditLogResource));
        // we set perPage via pagination to avoid resetting it when using filter
        this.list.pagination.perPage = 50;
        this.list.fetch(this.defaultFilter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/logs/auditlog/index.js